import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.appointmentAction.name.label,
  validators: []
}

export const form = {
  formKey: "appointmentActionSearch",
  fields: [
    name
  ]
}
